import Error from './Error';
import NotFound from './NotFound';
import AccessDenied from './AccessDenied';

export { Error, NotFound, AccessDenied };
export default { Error, NotFound, AccessDenied };
